import React from "react"
import AniLink from "gatsby-plugin-transition-link/AniLink"
import S from "./StyledHero"
import { Link } from "gatsby"

const FirstSection = () => (
  <S.HeroWrapper>
    <S.HeroBackground>
      <S.HeroBackgroundOverlay />
    </S.HeroBackground>

    <S.TitleWrapper>
      <S.MainTitle>Kierownik budowy</S.MainTitle>
      <S.MainTitle>Przegląd okresowy budynków</S.MainTitle>
      <S.MainTitle>Inspektor nadzoru inwestorskiego</S.MainTitle>
      <S.MainButton className="btn">
        <AniLink to="/nadzor-budowlany-realizacje-zachodniopomorskie/">
          Przeprowadzone realizacje
        </AniLink>
      </S.MainButton>
    </S.TitleWrapper>
    <S.ScrollDownButton href="/#oferta">
      <span />
      Przejdź do oferty
    </S.ScrollDownButton>
  </S.HeroWrapper>
)

export default FirstSection
